/**
 * @description
 */

import Api from '../../../path';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';
import { reportError } from 'common/src/services/errorLogger';

export interface IInput {
    /** 逗号分隔的 number 字符串 */
    resource_ids: string;
}

export interface IPPTToImgResultImg {
    url: string;
    size: number;
}

export enum ECovertStatus {
    NOT_START,
    END,
}

export interface IPPTToImgResult {
    status: ECovertStatus;
    resource_id: number;
    img_list: IPPTToImgResultImg[];
}

export type IOutput = IPPTToImgResult[];

export const pptToImgStatus = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.PPT_TO_IMG_STATUS, data)
        .then((res: IResponse<IOutput>) => {
            return res;
        })
        .catch((err: any) => {
            reportError({
                error: err,
                componentName: 'pptToImgStatus',
                props: data,
                additionalInfo: {
                    description: 'pptToImgStatus fetchData error',
                },
            });
            throw err;
        });
};

export const pptToImgStatusSync = fetchDataSync<IInput>(pptToImgStatus);
